import { TableCell, TableRow } from '@mui/material'
import { PlayerCardModels } from '@/state/player-card'
import dayjs from 'dayjs'

type Props = {
  row: PlayerCardModels.PlayerCardType
  onPlayerClick: (id: string) => void
}

export const PlayerSearchTableRow = ({ row, onPlayerClick }: Props) => {
  return (
    <TableRow
      hover
      sx={{ cursor: 'pointer' }}
      onClick={() => onPlayerClick(row?.id)}
    >
      <TableCell>{row?.id}</TableCell>
      <TableCell>{row?.username || '-'}</TableCell>
      <TableCell>
        {row?.firstName && row?.lastName
          ? `${row?.firstName} ${row?.lastName}`
          : '-'}
      </TableCell>
      <TableCell>{row?.email || '-'}</TableCell>
      <TableCell>
        {row?.registrationDate
          ? dayjs(row.registrationDate).format('YYYY-MM-DD HH:mm:ss')
          : '-'}
      </TableCell>
      <TableCell>{row?.country}</TableCell>
      <TableCell>{row?.city || '-'}</TableCell>
    </TableRow>
  )
}
